if ($(window).width() > 798) {

if ( $('.custom_product_section .product_block').length > 3 ) {
  $('.custom_product_section').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    responsive:{
        0:{
            items:1
        },
        798:{
            items:3
        },
        1000:{
            items:3
        }
    }
})  
}
}

  $('.slider-item').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})
  
  
